export default __webpack_public_path__ + "static/media/stylishholiday.ab401499.png";